import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { QUATRINHDAOTAO_API } from '@app/utils/apiUrl.js';
import { useMutation } from 'react-query';
import { Post } from '@app/utils/httpProvider';
import { messageToast, status200, status201 } from '@app/utils/define';

const schema = yup.object().shape({
    tuNgay: yup.string().required('Tu ngay khong duoc de trong'),
    denNgay: yup.string().required('Den ngay khong duoc de trong'),
    accountInfoId: yup.string().required('AccountInfoId khong duoc de trong'),
    trinhDoId: yup.string().required('TrinhDoId khong duoc de trong'),
    donViDaoTaoId: yup.string().required('DonViDaoTaoId khong duoc de trong'),
    nganhDaoTaoId: yup.string().required('NganhDaoTaoId khong duoc de trong'),
    xepLoaiDaoTaoId: yup.string().required('XepLoaiDaoTaoId khong duoc de trong'),
    hinhThucDaoTaoId: yup.string().required('HinhThucDaoTaoId khong duoc de trong')
});

const fieldConfigs = [
    ['accountInfoId', 'AccountInfoId'],
    ['trinhDoId', 'TrinhDoId'],
    ['donViDaoTaoId', 'DonViDaoTaoId'],
    ['nganhDaoTaoId', 'NganhDaoTaoId'],
    ['xepLoaiDaoTaoId', 'XepLoaiDaoTaoId'],
    ['hinhThucDaoTaoId', 'HinhThucDaoTaoId']
];

const QuaTrinhDaoTaoAdd = () => {
    const history = useHistory();

    const addFunc = useMutation((value) =>
        Post(QUATRINHDAOTAO_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        addFunc.mutate(values, {
            onSuccess: (res) => {
                if (res && (res.status === status200 || res.status === status201)) {
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                } else {
                    toast.error(messageToast.messageToastCreateError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Da co loi xay ra, vui long thu lai!');
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Them qua trinh dao tao</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        tuNgay: '',
                        denNgay: '',
                        accountInfoId: '',
                        trinhDoId: '',
                        donViDaoTaoId: '',
                        nganhDaoTaoId: '',
                        xepLoaiDaoTaoId: '',
                        hinhThucDaoTaoId: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tu ngay
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="date"
                                        name="tuNgay"
                                        value={values.tuNgay}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tuNgay}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tuNgay}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Den ngay
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="date"
                                        name="denNgay"
                                        value={values.denNgay}
                                        onChange={handleChange}
                                        isInvalid={!!errors.denNgay}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.denNgay}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            {fieldConfigs.map(([name, label]) => (
                                <Form.Group as={Row} className="mb-3" key={name}>
                                    <Form.Label className="col-sm-2 col-form-label">
                                        {label}
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder={`Nhap ${label}`}
                                            type="text"
                                            name={name}
                                            value={values[name]}
                                            onChange={handleChange}
                                            isInvalid={!!errors[name]}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors[name]}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            ))}

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={addFunc.isLoading}>
                                            Them
                                        </Button>
                                        <Button
                                            type="button"
                                            theme="secondary"
                                            onClick={() => history.goBack()}
                                        >
                                            Huy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default QuaTrinhDaoTaoAdd;
